<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <catGroomingBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import catGroomingBannerComponent from '../catGrooming/catGroomingBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    catGroomingBannerComponent,
    footerComponent,
  },
};
</script>
